// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "JavaScripts/" + chunkId + "." + {"4":"2f3bd5d5","5":"61fd0436","6":"b7de6e78","7":"9688cba1","8":"acbc8d16","9":"52992dda","10":"1ceb9cf6","11":"8b3adcb4","12":"78a1d589","13":"64d1d4f5","14":"4886aba2"}[chunkId] + ".min.js";
};